export class MultiLanguage {
  returnInLanguage(e, language) {
    const item = e.shortDescription;
    const ret = this.returnLanguage(item, language);
    return ret;
  }

  returnLongInLanguage(e, language) {
    const item = e.longtext;
    const ret = this.returnLanguage(item, language);
    return ret;
  }

  returnLanguage(e, language) {
    let ret;
    try {
      if (e.langText[0].sprachKennzeichen === language) {
        ret = e.langText[0].text;
      } else {
        ret = e.langText[1].text;
      }
    } catch (err) {
      console.log('Error in MultiLanguage / returnLanguage:', err);
      ret = '';
    }
    return ret;
  }
}
